module.exports = __webpack_public_path__ + "fonts/AvenirNext-Heavy.c1a25b88.woff2";